import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../../APIHelpers/Responses";

export const storeCouponServices = {
  addNewStoreCoupon,
  updatedStoreCoupon,
  softDeleteRestoreStoreCoupon,
  deleteStoreCoupon,
  getStoreCouponList,
  getStoreSingleCoupon
};

// Add New Store Coupon
async function addNewStoreCoupon(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStoreCoupon`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Store Coupon
async function updatedStoreCoupon(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedStoreCoupon`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Store Coupon
async function softDeleteRestoreStoreCoupon(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStoreCoupon`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Store Coupon
async function deleteStoreCoupon(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStoreCoupon`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Store Coupon
async function getStoreCouponList(status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getStoreCouponList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreCouponList/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreCouponList/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Store Coupon
async function getStoreSingleCoupon(couponId, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getStoreSingleCoupon`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreSingleCoupon/${couponId}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreSingleCoupon/${couponId}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}